
const state = () => ({
  /**
   * This is the v-window component actual value.
   * @type Number
   */
  view: 1,

  /**
   * This is the active room ID.
   * @type Number
   */
  room: 0,
})

const getters = {}

const mutations = {
  view (state, v) {
    state.view = v
  },
  room (state, v) {
    state.room = v
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
